export default "/_next/static/images/img4-9a8d022f1e01fe340f38b33d66437542.png";